import { z } from "zod";
import { MetaSchema } from "./shared";

export const InvestmentPlanTypeAccessSchema = z.object({
  userId: z.string().uuid(),
  planTypes: z.array(z.enum(["NORMAL", "ACTIVATION", "ZERO"])),
});

const UsersInvestmentPlanTypeAccessResponse = z.object({
  data: InvestmentPlanTypeAccessSchema,
  meta: MetaSchema.default,
});

export type UsersInvestmentPlanTypeAccessResponseType = z.infer<
  typeof UsersInvestmentPlanTypeAccessResponse
>;

export default UsersInvestmentPlanTypeAccessResponse;
